import React, { useState } from "react";
import styled from "styled-components";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Floorplan from "./Container.Floorplan";
import { BackQuickLinkWrapper, QuickLinksWrapper } from "../../../List/styles";
import { chatActions } from "../../../../../_actions";
import { connect } from "react-redux";
import { quickLinkTypes } from "../../../List/quickLinkTypes";
import { useWindowSize } from "../../../Utility/hooks";

const ListFloorplansWraper = styled.div`
  height: calc(100vh - 250px);
  background: "red";
  background-color: white;
  overflow: hidden;
  overflow-y: scroll;
  top: 60px;
  z-index: 1000000;
  margin: 16px 0px 0px 16px;
  padding-right: 16px;

  ::-webkit-scrollbar {
    width: 6px;
    border-radius: 24px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f7f9fa;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    border-radius: 24px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakSmall}) {
    margin: 30px 32px 0px 42px;
    padding-right: 10px;
  }



  @media screen and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
    height: calc(100vh - 245px);
    width: 100%;
    top: 95px;
    padding-top: 90px;
    &.studentWrapper {
      height: calc(100vh - 295px);
    }
  }

  @media screen and (min-height: 900px) and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) {
    height: calc(100vh - 355px);

    &.studentWrapper {
      height: calc(100vh - 400px);
    }
  }

  .react-multi-carousel-list {
    width: 100%;
    overflow: visible;
    align-items: start;
  }

  .react-multi-carousel-item {
    height: 390px !important;
    pointer-events: none;
    transition: height 0.3s;
    opacity: 0.8;
  }

  .react-multi-carousel-item--active {
    pointer-events: auto;
    opacity: 1;
    scale: 1.05;
  }

  .react-multi-carousel-dot button {
    width: 19px;
    border-radius: 10px;
    height: 3px;
    border-color: #DCDCDC;
  }

  .react-multi-carousel-dot--active button {
    border-color: var(--Primary-Blue);
    width: 31px;
  }

  .react-multiple-carousel__arrow--right {
    bottom: -90px;
    background: #eee;
    @media screen and (max-height: 850px )and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
           bottom: 5px;
       }
  }
  .react-multiple-carousel__arrow--left {
    bottom: -90px;
    background: #eee;

    @media screen and (max-height: 850px )and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
            bottom: 5px;
       }
  }
  .react-multiple-carousel__arrow:before {
    color: #555F78;
  }

  .react-multi-carousel-dot-list {
    bottom: -80px;

    @media screen and (max-height: 850px )and (min-width: ${(props) =>
      props.theme.screenSizes.breakLaptop}) {
        bottom: 15px;
       }
  }

  .react-multi-carousel-track {
    display: flex;
    align-items: center;
  }

  .QuickLinksWrapper {
    width: auto !important;
    background: white;
    z-index: 1;
  }
`;

const responsive = {
  desktop: {
    breakpoint: { max: 5000, min: 1024 },
    items: 1,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 600 },
    items: 1,
    slidesToSlide: 1,
  },
};

function ListFloorplans({ data, floorplans, onClick }) {
  const [isFloorplanImageZoomed, setIsFloorplanImageZoomed] = useState(false);
  const { width } = useWindowSize();
  const typeBot = data[0].bot_type === "Student";
  return (
    <ListFloorplansWraper className={`ListFloorplansWraper ${typeBot && 'studentWrapper'}`}>
       { data.map((el, i) => {
          return (
            <Floorplan
              width="600"
              onClick={onClick}
              className="Floorplan"
              data={el}
              isFloorplanImageZoomed={setIsFloorplanImageZoomed}
              key={`floorplan-${i}`}
            />
          );
        })}

      <div>
        <QuickLinksWrapper className="QuickLinksWrapper" specials>
          {floorplans
            .filter((ql) => ql.subType && ql.subType !== "back")
            .map((quickLink, key) => {
              const type = quickLink.type || "text";
              const QuickLinkType = quickLinkTypes[type];

              return (
                <QuickLinkType
                  key={`quicklinks-${key}`}
                  data={quickLink}
                  specials
                />
              );
            })}
        </QuickLinksWrapper>
        {width && width >= 500 && (
          <BackQuickLinkWrapper className="BackQuickLinkWrapper" specials>
            {floorplans
              .filter((ql) => ql.subType && ql.subType === "back")
              .map((quickLink, key) => {
                const type = quickLink.type || "text";
                const QuickLinkType = quickLinkTypes[type];
                return (
                  <QuickLinkType
                    key={`quickLinks-${key}`}
                    data={quickLink}
                    specials
                  />
                );
              })}
          </BackQuickLinkWrapper>
        )}
      </div>
    </ListFloorplansWraper>
  );
}

const mapStateToProps = (state) => ({
  floorplans: state.floorplan.floorplans,
});

const mapDispatchToProps = {
  send: chatActions.send,
};

export default connect(mapStateToProps, mapDispatchToProps)(ListFloorplans);
